import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsFinancialYearRoute: InvariantJiraRoute = {
	name: 'polaris-settings-financial-year',
	path: '/jira/settings/products/jira-product-discovery/financial-year',
	exact: true,
};
